<ng-container *transloco="let t">
  <div class="flex h-full flex-col gap-4">
    <app-keyword-list-manager
      class="min-h-0 flex-1"
      [initTargetings]="data.blacklist ?? []"
      (targetingsChanged)="targetings.set($event)"
      [isReadOnly]="data.isReadOnly"
    />
    <div class="flex justify-end gap-2">
      @if (data.isReadOnly) {
        <button iButton variant="secondary" size="sm" (click)="close()">{{ t("common.close") }}</button>
      } @else {
        <button iButton variant="secondary" size="sm" (click)="close()">{{ t("common.cancel") }}</button>
        <button iButton type="submit" size="sm" [disabled]="data.isReadOnly" (click)="save()">
          {{ t("common.save") }}
        </button>
      }
    </div>
  </div>
</ng-container>
